import React from "react"
import Layout from "../../components/Layout"
import { Helmet } from "react-helmet"
import { StaticImage } from "gatsby-plugin-image"

const purplecowCommunity = () => {
  return (
    <Layout>
      <Helmet>
        {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
        <title>Thank you for our busiest quarter yet! 💜🐄</title>
      </Helmet>
      <div className="prose flex flex-col prose-lg lg:prose-xl mx-5 sm:mx-10 md:mx-40 xl:mx-80 2xl:mx-96">
        <div className="flex justify-center flex-col">
          <StaticImage
            layout="constrained"
            src="images/keeping_people_connected.png"
            alt="Purple Cow Internet - huge growth"
          />
          <h1 className="mt-7">Helping Our Herd – One Neighbour at a Time</h1>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            Since launching the <strong className="font-bold">Neighbour in Need</strong> program last
            October, we’ve seen firsthand how powerful small acts of kindness
            can be. This initiative was created with one simple goal: to make
            sure no one in our herd loses their connection when life gets tough.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            Thanks to our amazing herd members who’ve added just $2/month to
            their bill, we’ve raised <strong className="font-bold">$2,366.00</strong> to date. Here’s
            how the monthly support has grown:
          </p>
          <ul className="list-disc pl-6">
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              October 2024 – $52
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              November – $206
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              December – $330
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              January – $400
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              February – $472
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              March – $600
            </li>
            <li className="mt-8 leading-relaxed text-xl text-[#374151]">
              April (so far) – $304
            </li>
          </ul>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            To date, <strong className="font-bold">38 herd members</strong> have
            received help during tough times. Just last week, we were able to
            assist <strong className="font-bold">Jaime</strong>, who had to
            choose between rent and internet after a family emergency. We also
            helped <strong className="font-bold">Sarah</strong>, who lost her
            job and was waiting for a new one to begin.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            And most recently, we were able to support{" "}
            <strong className="font-bold">Darlene</strong>, who had been
            hospitalized and unable to work, leaving her behind on bills and
            unsure how to stay connected. Thanks to this fund, Darlene didn’t
            have to worry about losing access when she needed it most.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            So far, <strong className="font-bold">$2,130.00</strong> has gone
            directly to helping people stay connected.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            The truth is—there’s a lot of need out there. While our
            contributions so far have made a meaningful difference, they’re just
            a drop in the milk bucket. But we believe every drop counts.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            If you’re part of the herd and haven’t joined the Neighbour in Need
            program yet, we encourage you to consider adding $2/month to help
            lift someone else up when life gets heavy. Feel free to shoot us a
            text at <strong className="font-bold">902-800-2660</strong> and we
            will get this added to your account.
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            <strong className="font-bold">
              Together, we’re proving that a better kind of internet company is
              possible—one that shows up for its community.
            </strong>
          </p>
          <p className="my-8 leading-relaxed text-xl text-[#374151]">
            Bradley Farquhar - CEO
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default purplecowCommunity
